export * from './catalog.service';
export * from './catalog.interface';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/catalog/shared/index.ts